import styled from "styled-components";
export const MapContainer = styled.div `
  width: 100vw;
  height: var(--app-height);

  .mapboxgl-ctrl-geocoder.mapboxgl-ctrl {
    width: 350px;
  }
`;
